import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(price);
}

/**
 * Get delivery timeframe based on order value
 * @param {number} orderValue - The total order value
 * @returns {string} - Delivery timeframe in days
 */
export function getDeliveryTimeframe(orderValue) {
  if (orderValue <= 50000) return '7 days';
  if (orderValue <= 100000) return '10 days';
  if (orderValue <= 300000) return '15 days';
  if (orderValue <= 500000) return '20 days';
  return '25 days';
}

/**
 * Calculate per person cost for workstation products
 * @param {number} price - Product price
 * @param {string} subcategory - Product subcategory
 * @returns {number} - Per person cost
 */
export function calculatePerPersonCost(price, subcategory) {
  switch (subcategory) {
    case 'Cluster of 2':
      return Math.round(price / 2);
    case 'Cluster of 4':
    case 'Cluster of 4 Large':
      return Math.round(price / 4);
    default:
      return price;
  }
}

/**
 * Check if a product is a workstation type
 * @param {string} category - Product category
 * @returns {boolean}
 */
export function isWorkstationProduct(category) {
  return category === 'Modular Office Workstation';
}

export function calculatePricing(subtotal) {
  // No automatic discounts - discounts only through coupon codes
  const discount = 0;
  const discountPercent = 0;
  const amountAfterDiscount = subtotal;

  // GST calculation
  const cgst = amountAfterDiscount * 0.09;
  const sgst = amountAfterDiscount * 0.09;
  const totalGst = cgst + sgst;

  // No automatic delivery charges - determined by delivery location
  const deliveryCharges = 0;

  const total = amountAfterDiscount + totalGst + deliveryCharges;

  return {
    subtotal: Math.round(subtotal),
    discountPercent,
    discount: Math.round(discount),
    amountAfterDiscount: Math.round(amountAfterDiscount),
    cgst: Math.round(cgst),
    sgst: Math.round(sgst),
    totalGst: Math.round(totalGst),
    deliveryCharges,
    total: Math.round(total)
  };
}
